import { Component, OnInit } from "@angular/core";
import { ActionSheetController, IonicModule, ModalController, NavController, NavParams } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import { ImagePipe } from "src/app/pipes/image/image";
import { CropperComponent } from "src/app/components/cropper/cropper.component";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { Capacitor, registerPlugin } from "@capacitor/core";
import { ToastController } from "@ionic/angular/standalone";
import { UserProvider } from "src/app/services/user/user";

const PhotoEditorPlugin = registerPlugin<{
  edit(options: { imagePath: string }): Promise<{ base64: string }>;
}>("PhotoEditorPlugin");
@Component({
  selector: "app-pessoa-foto",
  templateUrl: "./pessoa-foto.page.html",
  styleUrls: ["./pessoa-foto.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, ImagePipe, TranslateModule, LoadingSpinnerComponent],
})
export class PessoaFotoPage implements OnInit {
  uploadImage: any;
  pessoa: any;
  public path: string | undefined;
  pessoaFoto: any;
  loaded = false;
  meuCadastro = false;
  isEnablePicker = false;
  addFamiliar: boolean;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public navParams: NavParams,
    private translate: TranslateService,
    public actionSheetCtrl: ActionSheetController,
    public pessoaProvider: PessoaProvider,
    public userProvider: UserProvider,
    private toastController: ToastController
  ) {
    this.pessoa = this.navParams.get("pessoa");
    this.meuCadastro = this.navParams.get("meuCadastro");
    this.addFamiliar = this.navParams.get("addFamiliar");
    this.pessoaFoto = this.pessoa.foto;

    this.isEnablePicker = this.meuCadastro
      ? true
      : this.userProvider.hasPermissao("VISITANTE_EDITAR") || this.userProvider.hasPermissao("PESSOA_EDITAR");
  }

  ngOnInit() {
    setTimeout(() => (this.loaded = true), 1000);
  }

  public closeModal(type: boolean) {
    this.modalCtrl.dismiss(type);
  }

  removePic() {
    this.pessoaFoto = null;
    this.uploadImage = null;
    this.pessoaProvider.updateFoto(null, this.pessoa.id).subscribe((result) => {
      if (result) {
        setTimeout(() => (this.loaded = true), 1000);
        this.pessoaProvider.getbyId(this.pessoa.id).subscribe((resultByid) => {
          this.pessoaFoto = resultByid.foto;
        });
      }
    });
  }

  async foto() {
    const actionSheet = await this.actionSheetCtrl.create({
      buttons: [
        {
          text: "Apagar Foto",
          handler: () => {
            this.removePic();
          },
        },
        {
          text: "Tirar foto",
          data: {
            action: "takePhoto",
          },
          handler: () => {
            this.getImage(CameraSource.Camera);
          },
        },
        {
          text: "Escolher foto",
          data: {
            action: "choosePhoto",
          },
          handler: () => {
            this.getImage(CameraSource.Photos);
          },
        },
        {
          text: "Cancelar",
          role: "cancel",
          data: {
            action: "cancel",
          },
        },
      ],
    });

    actionSheet.present();
  }

  async openEditorWithImage(path: string) {
    try {
      const result = await PhotoEditorPlugin.edit({
        imagePath: path,
      });

      if (this.addFamiliar) {
        this.pessoaProvider.updateFotoPessoaSemId(result.base64).subscribe((picker) => {
          const data = {
            base64: result.base64,
            foto: picker,
          }
          this.modalCtrl.dismiss(data);
          return;
        });
      } else if (result.base64) {
        this.submitPhoto(result.base64);
      }
    } catch (error) {
      console.error("Erro ao editar imagem:", error);
    }
  }

  async getImage(source: CameraSource): Promise<void> {
    try {
      const { path } = await Camera.getPhoto({
        quality: 100,
        resultType: CameraResultType.Uri,
        presentationStyle: "popover",
        source,
      });

      this.path = path;
      if (!this.path) {
        console.warn("Imagem não foi capturada corretamente.");
        return;
      }

      if (Capacitor.getPlatform() === "ios") {
        await this.openEditorWithImage(this.path);
      } else {
        this.openCameraAndCrop(this.path);
      }
    } catch (error) {
      console.error(`Erro ao obter imagem da ${source === CameraSource.Camera ? "câmera" : "galeria"}:`, error);
    }
  }

  async openCameraAndCrop(imageBase64: any) {
    const modal = await this.modalCtrl.create({
      component: CropperComponent,
      componentProps: { imageBase64 },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.submitPhoto(data);
    }
  }

  submitPhoto(data: any) {
    this.loaded = false;
    this.pessoaProvider.updateFoto(data, this.pessoa.id).subscribe(
      (result: any) => {
        if (result && !result.error) {
          setTimeout(() => (this.loaded = true), 1000);
          this.pessoaProvider.getbyId(this.pessoa.id).subscribe((resultByid) => {
            this.pessoaFoto = resultByid.foto;
            this.closeModal(resultByid.foto);
          });
        } else {
          this.loaded = true;
          this.presentToast(result.error || "Erro desconhecido.");
        }
      },
      (err) => {
        this.loaded = true;
        this.presentToast("Ocorreu um erro ao enviar a imagem.");
      }
    );
  }

  async presentToast(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      position: "top",
      color: "danger",
    });
    toast.present();
  }
}
